import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./Motor.css";
import MotorSlider from "./Sliders/MotorSlider";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DeleteEquipments, UpdateEquipments } from "../../api/api";
import ErrorToast from "../toasts/ErrorToast";
import { MqttContext } from "../../context/MQTTContext";
import SuccessToast from "../toasts/SuccessToast";
import WarningAlert from "../sweeAlerts/WarningAlert";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Motor = () => {
  const {
    authUser,
    setIsLoading,
    equipmentButtons,
    devices,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    handleChangeNameModal,
    setChangeNameOptions,
    update,
    selectedEquipment,
    refreshMqtt,
    currentRoom,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);
  const [buttons, setButtons] = useState([]);
  const [buttonStates, setButtonStates] = useState({});
  const [changedButton, setChangedButton] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [ColoredButton, setColoredButton] = useState(null);
  const [editEquipmentName, setEditEquipmentName] = useState(false);
  const [editedEquipmentName, setEditedEquipmentName] = useState("");

  const navigate = useNavigate();
  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  const buttonsRef = useRef(buttons);
  const buttonStatesRef = useRef(buttonStates);

  useEffect(() => {
    buttonsRef.current = buttons;
    buttonStatesRef.current = buttonStates;
  }, [buttons, buttonStates]);

  useEffect(() => {
    let btns = equipmentButtons
      .filter((eq_btn) => eq_btn.equipment_id == eq_id)
      .map((btn) => ({
        ...btn,
        digit: Number(btn.digit),
      }));
    setButtons(btns);
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
    if (btns.length) {
      let clientsId = [];
      btns.forEach((button) => {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        if (
          device.is_bus == 1 &&
          clients[device?.bridge_device?.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            const deviceSerial =
              String.fromCharCode(message[3]) +
              String.fromCharCode(message[4]) +
              String.fromCharCode(message[5]) +
              String.fromCharCode(message[6]) +
              String.fromCharCode(message[7]) +
              String.fromCharCode(message[8]);
            if (
              device.bridge_device.internet_token.slice(-2) ===
                endOfTwoCharToken &&
              device.serial === deviceSerial &&
              (message[10] == 1 || message[10] == 3) &&
              message[2] == 14
            ) {
              if (message.length == 36) {
                if (message[12] !== 6 && message[12] !== 7) {
                  ErrorToast("تنظیمات مد کاری دستگاه بررسی شود");
                  return 0;
                }
                let outTemp =
                  message[11] <= 127
                    ? message[11] / 2
                    : (message[11] - 256) / 2;
                setSliderValue(message[15]);
                setButtonStates((prevStates) => ({
                  ...prevStates,
                  [device.id]: {
                    outTemp: outTemp == -64 || outTemp == 255 ? "-" : outTemp,
                    status: message[13],
                    mode: message[13],
                    setting_temp: message[14],
                    deviation_temp: message[15],
                    motor_temp: message[16],
                    return_temp1: message[17],
                    return_temp2: message[18],
                    return_temp3: message[19],
                    status_pomp1: message[20],
                    status_pomp2: message[21],
                    status_pomp3: message[22],
                  },
                }));
                setColoredButton(null);
              }
            }
          };

          // clients[device.bridge_device.id].removeAllListeners("message");
          clients[device.bridge_device.id].on("message", messageListener);

          let buffer = new ArrayBuffer(10);
          let asciiCode = new Uint8Array(buffer);
          asciiCode[0] = 14;
          asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
          asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
          asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
          asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
          asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
          asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
          asciiCode[7] = device.type + 50;
          asciiCode[8] = 3;
          asciiCode[9] = 0;

          let message = device.bridge_device.internet_token;

          // ترکیب رشته و بافر
          let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

          clients[device.bridge_device.id].publish(
            device.bridge_device.serial + "/sys",
            combinedMessage,
          );
          setColoredButton(button.id);
          clientsId = [...clientsId, device.id];
        } else if (
          device.id &&
          device.username &&
          device.password &&
          clients[device.id] &&
          !clientsId.includes(device.id)
        ) {
          const messageListener = (topic, message) => {
            const endOfTwoCharToken =
              String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
            if (
              device.internet_token.slice(-2) === endOfTwoCharToken &&
              (message[2] == 3 || message[2] == 1)
            ) {
              if (message.length == 28) {
                if (message[4] !== 6 && message[4] !== 7) {
                  ErrorToast("تنظیمات مد کاری دستگاه بررسی شود");
                  return 0;
                }
                let outTemp =
                  message[3] <= 127 ? message[3] / 2 : (message[3] - 256) / 2;
                setSliderValue(message[7]);
                setButtonStates((prevStates) => ({
                  ...prevStates,
                  [device.id]: {
                    outTemp: outTemp == -64 || outTemp == 255 ? "-" : outTemp,
                    status: message[5],
                    mode: message[5],
                    setting_temp: message[6],
                    deviation_temp: message[7],
                    motor_temp: message[8],
                    return_temp1: message[9],
                    return_temp2: message[10],
                    return_temp3: message[11],
                    status_pomp1: message[12],
                    status_pomp2: message[13],
                    status_pomp3: message[14],
                  },
                }));
                setColoredButton(null);
              }
            }
          };

          // clients[button.device.id].removeAllListeners("message");
          clients[device.id].on("message", messageListener);

          const decimalArray = [3, 0];
          const asciiArray = decimalArray.map((num) =>
            String.fromCharCode(num),
          );

          clients[device.id].publish(
            device.serial + "/sys",
            device.internet_token + asciiArray.join(""),
          );
          setColoredButton(button.id);
          clientsId = [...clientsId, button.device_id];
        }
      });

      return () => {
        btns.forEach((button) => {
          let device = devices.find((d) => d.id == button.device_id);
          if (!device) {
            return;
          }
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            clients[device?.bridge_device?.id].removeAllListeners("message");
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            clients[device.id].removeAllListeners("message");
          }
        });
      };
    }
  }, [update, equipmentButtons, refreshMqtt, eq_id]);

  useEffect(() => {
    if (buttons.length) {
      let device = devices.find((d) => d.id == buttons[0].device_id);
      if (!device) {
        return;
      }
      if (device.is_bus == 1) {
        let buffer = new ArrayBuffer(13);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 14;
        asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
        asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
        asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
        asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
        asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
        asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
        asciiCode[7] = device.type + 50;
        asciiCode[8] = 1;
        asciiCode[9] = 9;
        asciiCode[10] = buttonStates[device.id].status;
        asciiCode[11] = 0;
        asciiCode[12] = sliderValue;

        let message = device.bridge_device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.bridge_device.id].publish(
          device.bridge_device.serial + "/sys",
          combinedMessage,
        );
        setColoredButton(buttons[0].id);
      } else if (
        device.id &&
        device.username &&
        device.password &&
        clients[device.id]
      ) {
        let buffer = new ArrayBuffer(5);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 1;
        asciiCode[1] = 9;
        asciiCode[2] = buttonStates?.[device.id]?.status;
        asciiCode[3] = 0;
        asciiCode[4] = sliderValue;

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);
        setColoredButton(buttons[0].id);
      }
    }
  }, [changedButton]);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleChangeSliderValue = (val) => {
    if (
      buttonStatesRef.current?.[buttonsRef.current?.[0]?.device_id] !==
      undefined
    ) {
      setSliderValue(val < 0 ? val + 256 : val);

      setChangedButton((prev) => !prev);
    }
  };

  const handleChangeMotorStatus = () => {
    if (buttonStates?.[buttons?.[0]?.device_id] !== undefined) {
      let device = devices.find((d) => d.id == buttons[0].device_id);
      if (!device) {
        return;
      }
      setButtonStates((prev) => ({
        ...prev,
        [device.id]: {
          ...prev[device.id],
          status: prev[device.id].status ? 0 : 1,
        },
      }));

      setChangedButton(!changedButton);
    }
  };

  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id === equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  return (
    <div
      className="card h-100"
      style={{ backgroundColor: "#fff0", boxShadow: "none" }}
    >
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
        style={{ zIndex: "1" }}
      >
        <h5 className={editEquipmentName ? "d-none" : ""}>
          {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
        </h5>
        <div
          className={editEquipmentName ? "mt-2 d-block" : "d-none"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div>
            <input
              id="smallInput"
              className="form-control form-control-sm text-center"
              name="room_name"
              type="text"
              placeholder="نام تجهیز را وارد کنید"
              value={editedEquipmentName}
              onChange={(e) => setEditedEquipmentName(e.target.value)}
            />
          </div>
          <div className="mt-1">
            <button
              type="button"
              className="btn btn-xs btn-success-app submit-add-room me-2"
              onClick={() =>
                handleChangeEquipmentName(
                  equipments.find((eq) => eq.id == eq_id)?.id,
                )
              }
            >
              ثبت
            </button>
            <button
              type="button"
              className="btn btn-xs btn-success-app"
              onClick={(e) => setEditEquipmentName(false)}
            >
              انصراف
            </button>
          </div>
        </div>
        <div>
          {authUser.is_admin ? (
            <>
              <button
                type="button"
                className="btn btn-success-app btn-icon me-2"
                style={{ borderColor: "rgb(0, 165, 148)" }}
                onClick={() => handleRemoveEquipment(selectedEquipment.id)}
              >
                <i className="bx bx-trash"></i>
              </button>
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={(e) => {
                        e.preventDefault();
                        handleEquipmentsListModal(true);
                      }}
                    >
                      افزدون تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to={
                        "/room/select-device/" +
                        room_id +
                        "/" +
                        eq_id +
                        "/" +
                        eq_type
                      }
                    >
                      افزدون کانال به تجهیز
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      onClick={() =>
                        handleChangeEquipmentName(
                          equipments.find((eq) => eq.id == eq_id)?.id,
                        )
                      }
                    >
                      تغییر نام تجهیز
                    </Link>
                  </li>
                </ul>
              </div>
            </>
          ) : null}

          {/* <BackButton url={"/room/" + room_id} /> */}
        </div>
      </div>
      <div
        className={
          devices.find((d) => d.id == buttons?.[0]?.device_id)
            ? "card-body scrollbar mt-sm-2 p-1"
            : "d-none"
        }
        style={{ paddingBottom: "10rem !important" }}
      >
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
        <div
          className="row motor-box rounded-3"
          style={{
            boxShadow:
              ColoredButton != buttons?.[0]?.id
                ? ""
                : "0 0.25rem 1rem rgba(0, 122, 255, 0.45)",
          }}
        >
          <div className="col-12 text-end">
            <span style={{ fontSize: "11px" }}>
              S/{devices.find((d) => d.id == buttons?.[0]?.device_id)?.serial}
            </span>
          </div>
          <div className="col-12">
            <div className="d-flex justify-content-around">
              <div>مشعل</div>
              <div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    checked={
                      buttons.length
                        ? buttonStates?.[buttons?.[0].device_id]?.status
                          ? "checked"
                          : ""
                        : ""
                    }
                    onChange={handleChangeMotorStatus}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-center slider-power">
            <MotorSlider
              value={sliderValue}
              setValue={handleChangeSliderValue}
              setChangedButton={setChangedButton}
              changedButton={changedButton}
            />
          </div>
          <div className="col-12 mt-4">
            <div className="d-flex justify-content-between flex-wrap">
              <div className="motor-status" style={{ fontSize: "11px" }}>
                <p className="text-center">دمای بیرون</p>
                <p className="text-center" dir="ltr">
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.outTemp != 192 &&
                      buttonStates?.[buttons?.[0]?.device_id]?.outTemp != 255
                      ? buttonStates?.[buttons?.[0]?.device_id]?.outTemp
                      : "-"
                    : "-"}
                </p>
                <img src="/assets/img/app-icons/Jf.png" alt="" />
                <p className="text-center">پمپ 3</p>
                <p className="text-center" dir="ltr">
                  {/* {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device?.id]?.status_pomp3
                      ? "روشن"
                      : "خاموش"
                    : "-"} */}
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.status_pomp3 == 1
                      ? "روشن"
                      : buttonStates?.[buttons?.[0]?.device_id]?.status_pomp3 ==
                          0
                        ? "خاموش"
                        : "-"
                    : "-"}
                </p>
                <p className="text-center" dir="ltr">
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.return_temp3 !=
                        192 &&
                      buttonStates?.[buttons?.[0]?.device_id]?.return_temp3 !=
                        255
                      ? buttonStates?.[buttons?.[0]?.device_id]?.return_temp3
                      : "-"
                    : "-"}
                </p>
              </div>
              <div className="motor-status" style={{ fontSize: "11px" }}>
                <p className="text-center">دمای موتورخانه</p>
                <p className="text-center" dir="ltr">
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.motor_temp !=
                        192 &&
                      buttonStates?.[buttons?.[0]?.device_id]?.motor_temp != 255
                      ? buttonStates?.[buttons?.[0]?.device_id]?.motor_temp
                      : "-"
                    : "-"}
                </p>
                <img src="/assets/img/app-icons/Jf.png" alt="" />
                <p className="text-center">پمپ 2</p>
                <p className="text-center" dir="ltr">
                  {/* {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device?.id]?.status_pomp2
                      ? "روشن"
                      : "خاموش"
                    : "-"} */}
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.status_pomp2 == 1
                      ? "روشن"
                      : buttonStates?.[buttons?.[0]?.device_id]?.status_pomp2 ==
                          0
                        ? "خاموش"
                        : "-"
                    : "-"}
                </p>
                <p className="text-center" dir="ltr">
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.return_temp2 !=
                        192 &&
                      buttonStates?.[buttons?.[0]?.device_id]?.return_temp2 !=
                        255
                      ? buttonStates?.[buttons?.[0]?.device_id]?.return_temp2
                      : "-"
                    : "-"}
                </p>
              </div>
              <div className="motor-status" style={{ fontSize: "11px" }}>
                <p className="text-center">دمای تنظیم</p>
                <p className="text-center" dir="ltr">
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.setting_temp !=
                        192 &&
                      buttonStates?.[buttons?.[0]?.device_id]?.setting_temp !=
                        255
                      ? buttonStates?.[buttons?.[0]?.device_id]?.setting_temp
                      : "-"
                    : "-"}
                </p>
                <img src="/assets/img/app-icons/Jf.png" alt="" />
                <p className="text-center">پمپ 1</p>
                <p className="text-center" dir="ltr">
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.status_pomp1 == 1
                      ? "روشن"
                      : buttonStates?.[buttons?.[0]?.device_id]?.status_pomp1 ==
                          0
                        ? "خاموش"
                        : "-"
                    : "-"}
                </p>
                <p className="text-center" dir="ltr">
                  {buttons.length
                    ? buttonStates?.[buttons?.[0]?.device_id]?.return_temp1 !=
                        192 &&
                      buttonStates?.[buttons?.[0]?.device_id]?.return_temp1 !=
                        255
                      ? buttonStates?.[buttons?.[0]?.device_id]?.return_temp1
                      : "-"
                    : "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Motor);
